import React from 'react';
import { formatCurrency } from '@avila-tek/ui/src';
import { Client, ShopCartItem, ShopItem } from '../../../../models';
import { useUser } from '../../../../hooks';
import ItemQuantity from '../../../shopcart/ShopcartSummary/ItemQuantity';
import fallbackImg from '../../../../public/images/product-card-fallback.png';
import EmployeeDetail from './EmployeeDetail';
import { roles } from '../../../../static';

interface OrderItemProps {
  title: string;
  subtitle: string;
  price: number;
  quantity: number;
  photoSrc: string;
  clients: ShopItem[];
  shopCartItem: ShopCartItem;
  comparateAtPrice?: number;
}

function OrderItem({
  title,
  subtitle,
  price,
  quantity,
  photoSrc = '',
  clients,
  shopCartItem,
  comparateAtPrice,
}: OrderItemProps) {
  const [user] = useUser();
  const [isCollapse, setIsCollapse] = React.useState(false);
  const showButton =
    user.userType === roles.company && (clients as ShopItem).client;
  return (
    <div className="py-5 border-b border-neutral-cold-200 r">
      <div className="flex items-center flex-wrap ">
        <div className="hidden sm:block h-full rounded-lg">
          <img
            src={photoSrc === '' ? fallbackImg.src : photoSrc}
            className="object-cover h-36 w-36 rounded-lg"
            alt="product"
          />
        </div>
        <div className="flex flex-col space-y-1 sm:pl-5 ">
          <span className="font-semibold text-text-black text-lg">{title}</span>
          <span className="text-neutral-warm-500">{subtitle}</span>
        </div>
        <div className="ml-auto flex">
          <ItemQuantity
            canEdit={false}
            price={user.userType !== roles.ally ? price : comparateAtPrice}
            quantity={quantity}
            comparateAtPrice={comparateAtPrice}
          />
        </div>
        <div className="ml-auto flex space-x-3">
          {user.userType === roles.company || user.userType === roles.admin ? (
            <span className="text-neutral-warm-500">
              ${formatCurrency(price * quantity)}
            </span>
          ) : null}
          {user.userType === roles.ally && comparateAtPrice ? (
            <span className="text-neutral-warm-500 mr-2">
              ${formatCurrency(comparateAtPrice)}
            </span>
          ) : null}
        </div>
      </div>
      {showButton ? (
        <button
          className="flex text-neutral-warm-500 font-semibold mt-2 mx-auto"
          type="button"
          onClick={() => setIsCollapse(!isCollapse)}
        >
          <div className="flex items-center gap-5">
            <div className="border border-purple-100 bg-purple-50 text-purple-300 font-semibold rounded py-1 px-2 text-sm">
              {isCollapse ? 'Ocultar beneficiarios' : 'Ver beneficiarios'}
            </div>
          </div>
        </button>
      ) : null}
      {isCollapse
        ? clients.map((item) => (
            <EmployeeDetail
              user={(item.client as Client).user}
              shopItem={shopCartItem}
              quantity={item?.quantity ?? 0}
            />
          ))
        : null}
    </div>
  );
}

export default OrderItem;
